module.exports = __webpack_public_path__ + "img/img_Colleges9.6ec53f71.png";